import type { ListItemBlock, SlateBlock, SlateLeaf, TableCellBlock } from '@atlas/renderer';
import type { TextBlock } from '@atlas/tool/box/slate/isTextBlock';

export default function createTextBlock(
    type: TextBlock['type'] | ListItemBlock['type'] | TableCellBlock['type'] = 'paragraph',
    children: SlateLeaf[] = [{ text: '' }],
): SlateBlock {
    return { type, children };
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('createTextBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
